import Section from "@/Components/LayoutComponents/Section";
import React from "react";
import Slider from "./Slider";
import Image from "next/image";

interface EnterprisesProps {
  data?: any;
  isMobile?: boolean;
}

const Enterprises: React.FC<EnterprisesProps> = ({ data, isMobile }) => {
  const title = data?.title || "Why Enterprises Choose TRooTech for AI?";
  const description =
    data?.sub_title ||
    "TRooTech is not just an AI development company—we're a strategic engineering partner enabling organizations to embed intelligence into core systems and scale transformation with confidence.";

  return (
    <Section className="bg-background-dark relative">
      {!isMobile &&
        <>
          <Image
            src="/images/ServicesInner/Vector_blue.png"
            width={500}
            height={500}
            alt="banner-vector"
            className="absolute md:block hidden aspect-square w-[571px] bottom-0 left-0 z-0 bg-cover bg-no-repeat bg-center"
            quality={80}
            loading="eager"
            priority
          />
        </>
      }
      :
      {isMobile &&
        <>
          <Image
            src="/images/ServicesInner/Vector_blue2.png"
            width={500}
            height={500}
            alt="banner-vector"
            className="absolute md:hidden block aspect-square w-[571px] bottom-0 left-0 z-0 bg-cover bg-no-repeat bg-center"
            quality={80}
            loading="eager"
            priority
          />
          <Image
            src="/images/ServicesInner/Vector_green.png"
            width={500}
            height={500}
            alt="banner-vector"
            className="absolute aspect-square w-[665px] bottom-0 right-0 z-0 bg-cover bg-no-repeat bg-center"
            quality={80}
            loading="eager"
            priority
          />
        </>
      }

      <div className="container">
        <div className="lg:max-w-[904px] max-w-full">
          <h2 className="text-heading-1 sm:text-left text-center font-bold text-primary-text-white">
            {title}
          </h2>
          <p className="text-secondary-text-white text-center sm:text-left text-subtitle-2 font-regular mt-6">
            {description}
          </p>
        </div>
        <div className="xl:mt-10 mt-8 overflow-hidden">
          <Slider data={data} isMobile={isMobile} />
        </div>
      </div>
    </Section>
  );
};
export default Enterprises;